<kendo-grid [data]="sentDocuments$ | async" [size]="'small'">

    <kendo-grid-column field="name" title="{{'claims-center.claimDocumentation.documentType' | translate}}"
        media="(min-width: 1008px)">
        <ng-template kendoGridCellTemplate let-document="dataItem">
            <app-document-info-description [documentInfo]="document"></app-document-info-description>
        </ng-template>
    </kendo-grid-column>

      <kendo-grid-column field="actions" title="" media="(min-width: 1008px)">
        <ng-template kendoGridCellTemplate let-document="dataItem">
            <div fxLayout="row" *ngIf="!document.isArchived">
                <button kendoButton look="flat" icon="image" (click)="showContent(document)"> </button>
            </div>
            <div *ngIf="document.isArchived">
                <strong>{{'claims-center.claimDocumentation.documentIsAlreadyArchived' | translate}}</strong>
            </div>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="recipient" title="{{'claims-center.claimDocumentation.recipient' | translate}}"
        media="(min-width: 1008px)">
        <ng-template kendoGridCellTemplate let-document="dataItem">
            <span>{{document.recipient }}</span>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="timestamp" title="{{'claims-center.claimDocumentation.sentDate' | translate}}"
        media="(min-width: 1008px)">
        <ng-template kendoGridCellTemplate let-document="dataItem">
            <span>{{document.timestamp | date:'yyyy-MM-dd HH:mm:ss' }}</span>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="createdBy" title="{{'claims-center.claimDocumentation.sentBy' | translate}}"
        media="(min-width: 1008px)">
        <ng-template kendoGridCellTemplate let-document="dataItem">
            <span>{{document.createdBy }}</span>
        </ng-template>
    </kendo-grid-column>

    <!-- Mobile view for docs -->
    <kendo-grid-column title="" media="(max-width: 1007px)" class="mobile-grid-column">
        <ng-template kendoGridCellTemplate let-document="dataItem">
            <div fxLayout="column" class="form-block mobile-grid-column-item">

                <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">
                    <div fxFlex="98" fxLayout="column">
                        <app-document-info-description [documentInfo]="document"></app-document-info-description>
                    </div>
                </div>

                <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">
                    <div fxFlex="43">
                        {{'claims-center.claimDocumentation.recipient' | translate}}
                    </div>

                    <div fxFlex="45" fxLayout="column">
                        <span>{{document.recipient }}</span>
                    </div>
                </div>

                <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">
                    <div fxFlex="43">
                        {{'claims-center.claimDocumentation.sentDate' | translate}}
                    </div>

                    <div fxFlex="45" fxLayout="column">
                        <span>{{document.timestamp | date:'yyyy-MM-dd HH:mm:ss' }}</span>
                        <span>{{document.createdBy }}</span>
                    </div>

                </div>

                <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">

                    <div fxFlex="98" fxLayout="row-wrap" *ngIf="!document.isArchived">
                        <button kendoButton look="flat" icon="image" (click)="showContent(document)"> </button>
                    </div>
                    <div fxFlex="98" fxLayout="row-wrap" *ngIf="document.isArchived">
                        <strong>{{'claims-center.claimDocumentation.documentIsAlreadyArchived' | translate}}</strong>
                    </div>

                </div>

            </div>
        </ng-template>
    </kendo-grid-column>

</kendo-grid>
<div kendoDialogContainer #sentDocsDialog></div>